module.exports = __webpack_public_path__ + "static/media/team3.f3239f53.jpg";